import { FC, memo } from 'react'
import { createIcon, IconProps } from '@chakra-ui/icons'

import CustomIcon from '../../CustomIcon'

const PackageBoxIcon = createIcon({
  displayName: 'PackageBoxIcon',
  viewBox: '0 0 24 24',
  path: (
    <>
      <g strokeLinecap="round" strokeWidth="1.5" stroke="currentColor" fill="none" strokeLinejoin="round">
        <path d="M21 8.089v10.911 0c0 1.10457-.895431 2-2 2h-14 -8.74228e-08c-1.10457-4.82823e-08-2-.895431-2-2 0 0 0 0 0 0v-10.911l-7.4206e-08-5.32181e-05c-.00037454-.271195.0544093-.539634.161021-.788995l1.32-3.089 -1.01819e-07 2.37146e-07c.315626-.735124 1.03896-1.21143 1.83898-1.21095h11.36l-2.1236e-08-8.17124e-13c.800755 3.07977e-05 1.5243.477675 1.839 1.214l1.32 3.086 5.97111e-08 1.39911e-07c.106445.249414.161215.517821.161.789Z"></path>
        <path d="M3 8h17.99"></path>
        <path d="M14 3l1 5v3.225l-1.27569e-08 2.32323e-07c-.024758.450879-.408985.797129-.86.775h-4.28l-3.93405e-08 1.93029e-09c-.451016.0221296-.835242-.324121-.86-.775v-3.225l1-5"></path>
        <path d="M6 18h2"></path>
      </g>
      <path fill="none" d="M0 0h24v24h-24Z"></path>
    </>
  ),
})

const PackageBox: FC<IconProps> = (props) => {
  return <CustomIcon as={PackageBoxIcon} {...props} />
}

export default memo(PackageBox)
